export enum DeviceOS {
  Android = 'android',
  IOS = 'ios',
  Desktop = 'desktop',
}
